import * as React from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';
import { font } from '../../style/text';
import color from '../../style/color';
import { getLocalizedTexts } from '../../Locales';

const logo = { uri: '/assets/images/logos/logo-with-title.svg' };

/**
 * Simple failure page shown after a failed Flow payment redirect.
 * The extension detects this URL change and closes the tab.
 */
export default function GiftCardPaymentFailurePage() {
    const texts = getLocalizedTexts().giftCardPaymentPage.failurePage;
    return (
        <View style={styles.page}>
            <View style={styles.header}>
                <Image source={logo} style={styles.headerLogo} />
            </View>
            <View style={styles.centeredContent}>
                <Text style={styles.pageHeading}>{texts.title}</Text>
                <Text style={styles.pageSubtitle}>{texts.subtitle}</Text>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f7f8fa',
    },
    header: {
        paddingHorizontal: 40,
        paddingVertical: 19,
        borderBottomWidth: 1,
        borderBottomColor: '#e3e3e3',
        backgroundColor: color.white,
    },
    headerLogo: {
        width: 114,
        height: 55,
        resizeMode: 'contain',
    },
    centeredContent: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 80,
    },
    pageHeading: {
        fontFamily: font.wallopSansBold,
        fontSize: 24,
        lineHeight: 29,
        letterSpacing: -0.48,
        color: color.black,
    },
    pageSubtitle: {
        fontFamily: font.ambitRegular,
        fontSize: 14,
        lineHeight: 20,
        color: color.black,
        marginTop: 4,
    },
});
